import { useEffect, useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          params.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9u5755ca23r0tr1ar00', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else if (serverMsg && (typeof serverMsg === 'string') && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
        setFormStatus('error');
        setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
      } else {
        setFormStatus('error');
        setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '澳门彩官方指南',
    url: 'https://lotterytip.github.io',
    description: '澳门彩官方指南，提供澳门彩玩法规则、开奖结果、购买技巧与中奖攻略等全方位资讯服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />

            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
              关于我们
            </h1>
            <p className="text-sm text-foreground-600 mb-12">
              了解澳门彩官方指南的品牌故事与使命
            </p>

            <section className="mb-14">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 font-heading">
                品牌介绍
              </h2>
              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  澳门彩官方指南成立于2024年，是专注于澳门彩票资讯服务的专业平台。我们致力于为广大彩民提供最全面、最权威、最及时的澳门彩资讯内容，涵盖玩法规则、开奖结果、购买技巧及中奖攻略等多个领域。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  我们的编辑团队由资深彩票行业从业者和专业内容创作者组成，确保每篇文章都经过严谨的资料核实和专业的内容打磨。我们与澳门彩票行业保持密切的联系，持续追踪行业动态，为读者带来第一手的澳门彩资讯。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  澳门彩官方指南始终秉持"专业、客观、负责"的核心理念。我们提供的所有内容仅供资讯参考，不构成任何投注建议。我们积极倡导责任购彩，提醒每一位彩民理性参与、量力而行，将购彩视为健康的娱乐方式。
                </p>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 font-heading">
                我们的优势
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '权威可靠',
                    desc: '所有信息均来源于官方渠道，经过多重核实确保准确性',
                    color: 'primary',
                  },
                  {
                    icon: 'ri-flashlight-line',
                    title: '及时更新',
                    desc: '开奖结果和行业动态第一时间更新，不错过任何重要信息',
                    color: 'accent',
                  },
                  {
                    icon: 'ri-book-read-line',
                    title: '内容专业',
                    desc: '资深团队精心打造深度内容，从入门到进阶全覆盖',
                    color: 'secondary',
                  },
                  {
                    icon: 'ri-user-heart-line',
                    title: '用户至上',
                    desc: '以彩民需求为导向，持续优化内容质量与服务体验',
                    color: 'primary',
                  },
                  {
                    icon: 'ri-shield-star-line',
                    title: '责任为先',
                    desc: '积极倡导责任购彩理念，引导健康理性的购彩行为',
                    color: 'accent',
                  },
                  {
                    icon: 'ri-global-line',
                    title: '覆盖全面',
                    desc: '六大资讯分类满足不同需求，打造澳门彩一站式资讯平台',
                    color: 'secondary',
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-xl p-5 border border-background-200/70"
                  >
                    <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-${item.color}-100 text-${item.color}-600 mb-3`}>
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 font-heading">
                信誉与口碑
              </h2>
              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                  自成立以来，澳门彩官方指南凭借专业的内容质量和客观的资讯态度，赢得了广大彩民的信赖与好评。我们的文章被多家行业媒体和社区转载推荐，月均访问用户持续增长，已成为华语地区最具影响力的澳门彩资讯平台之一。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {[
                    { number: '50万+', label: '月均访问用户' },
                    { number: '200+', label: '原创深度文章' },
                    { number: '98%', label: '用户满意度' },
                  ].map((stat, i) => (
                    <div key={i} className="text-center p-4 rounded-lg bg-background-50">
                      <div className="text-2xl font-bold text-accent-600 font-heading">{stat.number}</div>
                      <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section id="contact">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 font-heading">
                联系我们
              </h2>
              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <p className="text-sm text-foreground-600 mb-6">
                  如有任何关于澳门彩的疑问、建议或合作意向，欢迎通过以下表单与我们联系。我们将在1-2个工作日内回复您。
                </p>

                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="space-y-4"
                >
                  <div className="honeypot-field" aria-hidden="true">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      readOnly
                      aria-hidden="true"
                    />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                        姓名 <span className="text-accent-500">*</span>
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors duration-200"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                        邮箱 <span className="text-accent-500">*</span>
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors duration-200"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      主题 <span className="text-accent-500">*</span>
                    </label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors duration-200"
                      placeholder="请输入咨询主题"
                    />
                  </div>

                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      留言内容 <span className="text-accent-500">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors duration-200 resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    ></textarea>
                  </div>

                  <div className="flex items-center gap-3">
                    <button
                      type="submit"
                      disabled={formStatus === 'loading'}
                      className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    >
                      {formStatus === 'loading' ? (
                        <>
                          <i className="ri-loader-4-line animate-spin mr-2"></i>提交中...
                        </>
                      ) : (
                        <>
                          <i className="ri-send-plane-line mr-2"></i>发送留言
                        </>
                      )}
                    </button>

                    {formStatus === 'success' && (
                      <span className="text-sm text-green-600 font-medium flex items-center gap-1">
                        <i className="ri-check-line"></i> 留言已发送，感谢您的联系！
                      </span>
                    )}

                    {formStatus === 'error' && (
                      <span className="text-sm text-red-600 font-medium">
                        {formError}
                      </span>
                    )}
                  </div>
                </form>
              </div>
            </section>

            <div className="mt-14 text-center">
              <p className="text-sm text-foreground-500 mb-4">
                想了解更多澳门彩资讯？浏览我们的热门分类
              </p>
              <div className="flex flex-wrap justify-center gap-2">
                <Link
                  to="/category/wanfa-guize"
                  className="px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  玩法规则
                </Link>
                <Link
                  to="/category/kaijiang-jieguo"
                  className="px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  开奖结果
                </Link>
                <Link
                  to="/category/goumai-jiqiao"
                  className="px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  购买技巧
                </Link>
                <Link
                  to="/category/zhongjiang-gonglve"
                  className="px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  中奖攻略
                </Link>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}